/**
 * Persistence layer with expiration based on sessionStorage.
 */

interface StorageInterface {
  length: number;
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
  clear(): void;
}

const storageMock: StorageInterface = {
  length: 0,
  getItem() {
    return null;
  },
  setItem() {},
  removeItem() {},
  clear() {},
};

class NamespacedsessionStorage {
  sessionStorage: StorageInterface;
  key: string;

  constructor(sessionStorage: StorageInterface, key: string) {
    this.sessionStorage = sessionStorage;
    this.key = key;
  }

  private _makeKey(key: string): string {
    return `${this.key}__${key}`;
  }

  getItem(name: string): string | null {
    return this.sessionStorage.getItem(this._makeKey(name));
  }

  setItem(name: string, value: string): void {
    this.sessionStorage.setItem(this._makeKey(name), value);
  }

  removeItem(name: string): void {
    this.sessionStorage.removeItem(this._makeKey(name));
  }
}

export default class browserPersistence {
  static KEY = "DUKE_BROWSER_PERSISTENCE";

  storage: NamespacedsessionStorage;

  constructor(
    sessionStorage: StorageInterface = globalThis.sessionStorage || storageMock
  ) {
    this.storage = new NamespacedsessionStorage(
      sessionStorage,
      (this.constructor as typeof browserPersistence).KEY ||
        browserPersistence.KEY
    );
  }

  getRawItem(name: string): string | null {
    return this.storage.getItem(name);
  }

  getItem(name: string): any {
    const now = Date.now();
    const item = this.storage.getItem(name);
    if (!item) {
      return undefined;
    }
    const { value, ttl, timeStored } = JSON.parse(item) as {
      value: string;
      ttl: number | undefined;
      timeStored: number;
    };

    if (ttl && now - timeStored > ttl * 1000) {
      this.storage.removeItem(name);
      return undefined;
    }
    if(value!=undefined)
    {
      return JSON.parse(value);
    }
  }

  setItem(name: string, value: any, ttl?: number): void {
    const timeStored = Date.now();
    this.storage.setItem(
      name,
      JSON.stringify({
        value: JSON.stringify(value),
        timeStored,
        ttl,
      })
    );
  }

  removeItem(name: string): void {
    this.storage.removeItem(name);
  }
}
